import * as React from 'react';

function SvgCreateTick(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" {...props}>
      <path
        d="M2.643 4.915a1.269 1.269 0 00-1.795.003l-.476.476a1.273 1.273 0 00-.003 1.795L4.83 11.65c.248.248.572.371.897.37.325-.003.652-.127.901-.376l8.997-8.997c.499-.498.5-1.305.004-1.8L15.152.37a1.277 1.277 0 00-1.8.003L5.725 7.998z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgCreateTick;
